  import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";  
  import Navbar from "./Webpage/navbar.js";  
  import { useRef, useState, useEffect } from "react";
  import FeedbackDashboard from "./Webpage/feedbackpage.js";  
  import Broadcast from "./Webpage/Broadcast.js";  
  import { SignIn } from "./Webpage/SignIn.js";  
  // import Footer from "./Webpage/footer.js";  
  import { KPIDashboard } from "./Webpage/Kpidetails.js";  
  import Chatbot from "./Webpage/chatbot.js";  
  import Super_Administator from "./Webpage/SuperAdministator.js";
import { LandPlotIcon } from "lucide-react";
  import Landing_page from "./Webpage/Landing_page.js";
  import BroadcastReport from "./Webpage/BroadcastReport.js";

  function App() {  

    const navbarRef = useRef(null);
    const [showSessionToast, setShowSessionToast] = useState(false);

    // ── Global fetch interceptor for 401 ─────────────────────────
    useEffect(() => {
      let toastShown = false;
      const originalFetch = window.fetch;

      window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        if (response.status === 401 && !toastShown) {
          const data = await response.clone().json().catch(() => ({}));

          if (
            data.error === 'Session expired' ||
            data.error === 'Not authenticated' ||
            data.error === 'Invalid token'
          ) {
            toastShown = true;
            setShowSessionToast(true);
          }
        }

        return response;
      };

      // ✅ Restore original fetch on unmount
      return () => {
        window.fetch = originalFetch;
      };
    }, []);

   function handleSessionExpiredOk() {
      setShowSessionToast(false);
      window.location.href = '/logout';
    }

    const ShowNavbar = () => {  
      const location = useLocation();  
      const excludedRoutes = ["/"];  
      return !excludedRoutes.includes(location.pathname) && <Navbar ref={navbarRef} />;
    };  
    
    // const ShowFooter = () => {  
    //   const location = useLocation();  
    //   const excludedRoutes = ["/"];  
    //   return !excludedRoutes.includes(location.pathname) && <Footer />;  
    // };  
    
    const ShowChatbot = () => {  
      const location = useLocation();  
      const excludedRoutes = ["/"];  
      return !excludedRoutes.includes(location.pathname) && <Chatbot />;  
    };  
    
    return (  
      <BrowserRouter>  
        <div className="App">  

          {/* ── SESSION EXPIRED TOAST ───────────────────────── */}
          {showSessionToast && (
            <div style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 99999,
              backdropFilter: 'blur(6px)'
            }}>
              <div style={{
                background: '#1a1a1a',
                border: '1px solid rgba(204,0,0,0.4)',
                borderRadius: '16px',
                padding: '36px 40px',
                maxWidth: '380px',
                width: '90%',
                textAlign: 'center',
                boxShadow: '0 0 60px rgba(204,0,0,0.2), 0 24px 48px rgba(0,0,0,0.5)',
                fontFamily: "'Segoe UI', sans-serif",
                animation: 'fadeInUp 0.3s ease'
              }}>

                {/* Icon */}
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: 'rgba(204,0,0,0.1)',
                  border: '1px solid rgba(204,0,0,0.3)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '26px'
                }}>
                  🔒
                </div>

                {/* Title */}
                <h3 style={{
                  color: '#fff',
                  fontSize: '18px',
                  fontWeight: '700',
                  margin: '0 0 10px 0',
                  letterSpacing: '-0.3px'
                }}>
                  Session Expired
                </h3>

                {/* Message */}
                <p style={{
                  color: 'rgba(255,255,255,0.5)',
                  fontSize: '14px',
                  lineHeight: '1.7',
                  margin: '0 0 28px 0'
                }}>
                  Your session has expired due to inactivity. Please log in again to continue.
                </p>

                {/* OK Button */}
                <button
                  onClick={handleSessionExpiredOk}
                  style={{
                    width: '100%',
                    padding: '13px',
                    background: 'linear-gradient(135deg, #cc0000, #990000)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '15px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    letterSpacing: '0.3px',
                    boxShadow: '0 4px 18px rgba(204,0,0,0.35)',
                    transition: 'opacity 0.2s, transform 0.2s'
                  }}
                  onMouseOver={e => {
                    e.target.style.opacity = '0.85';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseOut={e => {
                    e.target.style.opacity = '1';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  OK, Log me out
                </button>
              </div>
            </div>
          )}

          <ShowNavbar />  
          <Routes>  
            <Route path="/" element={<SignIn />} />  
            <Route path="/broadcastmessage" element={<Broadcast />} />  
            <Route path="/dashboard" element={<h1>This is for dashboard</h1>} />  
            <Route path="/kpidetails" element={<KPIDashboard />} />  
            <Route path="/profile" element={<h1>Profile</h1>} />  
            <Route path="/feedback" element={<FeedbackDashboard />} />  
            <Route path="/chatbot" element={<Chatbot />} />  
            <Route path="/role-assignment" element={<Super_Administator />} />            
            <Route path="/broadcastreport" element={<BroadcastReport/>} />  
            <Route path="/home" element={<Landing_page navbarRef={navbarRef} />} />  
            {/* <Route path="/logout" element={<SignIn />} /> */}  
          </Routes>  
        </div>  
      </BrowserRouter>  
    );  
  }  
    
  export default App;